import { getWhiteLabelBrand } from "@/lib/white-label-branding/getWhiteLabelBrand";
import { memo, useMemo, useState } from "react";
import { AppLoading } from "./AppLoading";

export default memo(
  function AppFrame({
    ready: r,
    proxyUrl,
    onError
  }: {
    ready: boolean;
    proxyUrl: string;
    onError?: React.ReactEventHandler<HTMLIFrameElement>;
  }) {
    const [loading, setLoading] = useState(true);
    const ready = r && proxyUrl !== "";
    const brand = getWhiteLabelBrand();

    const sameSiteProxyUrl = useMemo(() => {
      if (brand?.hostname)
        return proxyUrl.replace("numerous.com", brand.hostname);

      return proxyUrl;
    }, [proxyUrl, brand?.hostname]);

    return (
      <div className="w-full h-dvh">
        {(!ready || loading) && <AppLoading />}
        {ready && (
          <iframe
            src={sameSiteProxyUrl}
            onLoad={() => setLoading(false)}
            allowFullScreen={false}
            title="app"
            className="w-full h-full rounded"
            onError={onError || console.error}
          />
        )}
      </div>
    );
  },
  (prev, next) => {
    return prev.ready === next.ready && prev.proxyUrl === next.proxyUrl;
  }
);
